import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'diameterSet',
  title: 'Wheel Diameter Sets',
  type: 'document',
  fields: [
    defineField({
      name: 'frontDiameter',
      title: 'Front Wheel Diameter',
      type: 'reference',
      to: [{ type: 'diameter' }],
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'rearDiameter',
      title: 'Rear Wheel Diameter',
      type: 'reference',
      to: [{ type: 'diameter' }],
      validation: (Rule) => Rule.required(),
    }),
  ],
  preview: {
    select: {
      frontDiameter: 'frontDiameter.wheelDiameter',
      rearDiameter: 'rearDiameter.wheelDiameter',
    },
    prepare({ frontDiameter, rearDiameter }) {
      if (!frontDiameter || !rearDiameter) {
        return {
          title: 'No diameters selected',
          subtitle: 'Wheel diameter set',
        }
      }
      return {
        title: `${frontDiameter ? frontDiameter : 'N/A'}" / ${rearDiameter ? rearDiameter : 'N/A'}"`,
        subtitle: 'Wheel diameter set',
      }
    },
  },
  orderings: [
    {
      title: 'Front Diameter, Asc',
      name: 'frontDiameterAsc',
      by: [
        { field: 'frontDiameter.wheelDiameter', direction: 'asc' },
        { field: 'rearDiameter.wheelDiameter', direction: 'asc' },
      ],
    },
    {
      title: 'Front Diameter, Desc',
      name: 'frontDiameterDesc',
      by: [
        { field: 'frontDiameter.wheelDiameter', direction: 'desc' },
        { field: 'rearDiameter.wheelDiameter', direction: 'desc' },
      ],
    },
  ],
})
